<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useSurveyStore } from '@/stores/survey';
import IconCheckCircle from '@/components/icons/IconCheckCircle.vue';
import IconErrorCircle from '@/components/icons/IconErrorCircle.vue';

const surveyStore = useSurveyStore();

const { isCompleted, error } = storeToRefs(surveyStore);
</script>

<template>
	<div class="response container">
		<template v-if="isCompleted && !error">
			<div class="response__icon">
				<IconCheckCircle width="54" height="54" />
			</div>
			<h2>{{ $t('success_title') }}</h2>
			<p class="response__description">{{ $t('success_description') }}</p>
			<div class="response__info">{{ $t('soon_redirected') }}</div>
		</template>
		<template v-else>
			<div class="response__icon">
				<IconErrorCircle width="54" height="54" />
			</div>
			<h2>{{ $t('something_went_wrong') }}</h2>
			<p class="response__description">{{ $t('try_again') }}</p>
		</template>
	</div>
</template>

<style lang="scss">
@import '@/styles/utils/mixins.scss';
@import '@/styles/utils/variables.scss';

.response {
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex: 1 0 auto;
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;
	width: max-content;
	text-align: center;

	&__icon {
		margin-bottom: 0.375rem;
		line-height: 1;
	}

	h2 {
		margin-bottom: 0;
		font-size: var(--font-24);

		@include breakpoint(0, $md) {
			font-size: var(--font-18);
		}
	}

	&__description {
		margin-bottom: 0;
		font-size: var(--font-18);
		color: var(--gray-700);

		@include breakpoint(0, $md) {
			font-size: var(--font-16);
		}
	}

	&__info {
		border-top: 1px solid var(--gray-100);
		margin-top: 2.75rem;
		padding-top: 2.75rem;
		font-weight: 500;
	}
}
</style>
